import React, { useState, useEffect } from "react";
import axios from "axios";
import "./style.css";
import { useNavigate } from "react-router-dom";

const AddCourse = () => {
    const navigate = useNavigate();
  const [newCourse, setNewCourse] = useState({
    BatchNo: "",
    ClassName: "",
    CourseID: "",
    CourseName: "",
    CourseStartDate: "",
    CourseEndDate: "",
    Trainer: "",
    Assessor1: "",
    Assessor2: "",
    Examiner: "",
  });
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    axios
      .get("https://elearn-api.onrender.com/api/courses")
      .then((res) => setCourses(res.data))
      .catch(() => setError("Failed to load courses"));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Auto-set CourseID when CourseName changes
    if (name === "CourseName") {
      const selectedCourse = courses.find((c) => c.CourseName === value);
      setNewCourse((prev) => ({
        ...prev,
        CourseName: value,
        CourseID: selectedCourse?.CourseID || "",
      }));
    } else {
      setNewCourse((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    for (const key in newCourse) {
      if (!newCourse[key]) {
        setError(`Please fill ${key}`);
        setLoading(false);
        return;
      }
    }

    axios
      .post("https://elearn-api.onrender.com/api/insert-class", newCourse)
      .then(() => {
        setSuccess("Course added successfully!");
        setNewCourse({
          BatchNo: "",
          ClassName: "",
          CourseID: "",
          CourseName: "",
          CourseStartDate: "",
          CourseEndDate: "",
          Trainer: "",
          Assessor1: "",
          Assessor2: "",
          Examiner: "",
        });
      })
      .catch(() => setError("Failed to add course"))
      .finally(() => setLoading(false));
  };

  return (
    <div className="add-course-container">
      <h2 className="title">Add Class</h2>
  <button className="view-candidates-btn"  onClick={() => navigate("/all-class")} >
      View Class
    </button>
      {error && <p className="message error">{error}</p>}
      {success && <p className="message success">{success}</p>}

     <form className="add-course-form" onSubmit={handleSubmit}>
  {/* Course Name - always visible first */}
  <div className="form-group-course">
    <label htmlFor="CourseName">Course Name</label>
    <select
      id="CourseName"
      name="CourseName"
      value={newCourse.CourseName}
      onChange={handleChange}
    >
      <option value="">Select a course</option>
      {courses.map((course) => (
        <option key={course.CourseID} value={course.CourseName}>
          {course.CourseName}
        </option>
      ))}
    </select>
  </div>

  {/* Course ID - only shown after a CourseName is selected */}
  {newCourse.CourseName && (
    <div className="form-group-course">
      <label htmlFor="CourseID">Course ID</label>
      <input
        id="CourseID"
        type="text"
        name="CourseID"
        value={newCourse.CourseID}
        readOnly
      />
    </div>
  )}

  {/* Render the rest of the form */}
  {Object.entries(newCourse).map(([key, val]) => {
    if (key === "CourseName" || key === "CourseID") return null;

    return (
      <div className="form-group-course" key={key}>
        <label htmlFor={key}>{key.replace(/([A-Z])/g, " $1")}</label>
        <input
          id={key}
          type={key.toLowerCase().includes("date") ? "date" : "text"}
          name={key}
          value={val}
          onChange={handleChange}
          placeholder={`Enter ${key.replace(/([A-Z])/g, " $1").toLowerCase()}`}
          autoComplete="off"
        />
      </div>
    );
  })}

  <button className="btn-submit" type="submit" disabled={loading}>
    {loading ? "Adding..." : "Add Course"}
  </button>
</form>

    </div>
  );
};

export default AddCourse;
